import * as mdb from 'mdb-ui-kit';

const runGTM = (hasConsented) => {
  if (hasConsented) {
    //document.getElementById('consentModal').style.display = 'none';

    ((w, d, s, l, i) => {
      w[l] = w[l] || [];
      w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      });
      const f = d.getElementsByTagName(s)[0];
      const j = d.createElement(s);
      const dl = l !== 'dataLayer' ? `&l=${l}` : '';
      j.async = true;
      j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-NJD7RRG');
  }
};

// const checkHeight = (id) => {
//   const objHeight = document.getElementById(id);
//   const theHeight = objHeight.offsetHeight;
//   console.log("theHeight");
//   console.log(theHeight);
// }

const checkHeight = () => {
  const objHeight = document.getElementById('hs-form-iframe-0');
  const theHeight = objHeight.offsetHeight;
  const newHeight = theHeight + 5;
  document.getElementById('hs-form-container').style.height = newHeight + 'px';
}

// Select the node that will be observed for mutations
const targetNode = document.getElementById('hs-form-container');
// Options for the observer (which mutations to observe)
const config = { attributes: true, childList: true, subtree: true };
// Callback function to execute when mutations are observed
const callback = function(mutationsList, observer) {
  // Use traditional 'for loops' for IE 11
  for(const mutation of mutationsList) {
  //  console.log(mutationsList);
    if (mutation.type === 'childList') {
      console.log('A child node has been added or removed.');
      //checkHeight();
    }
    else if (mutation.type === 'attributes') {
      console.log('The ' + mutation.attributeName + ' attribute was modified.');
      if(mutation.attributeName == 'height'){
        checkHeight();
      }
    }
  }
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(targetNode, config);

// Later, you can stop observing
//observer.disconnect();

//
// document.getElementById('hs-form-iframe-0').onload = function() {
//   alert('myframe is loaded');
// };

window.cookieconsent.initialise({
  container: document.getElementById('content'),
  palette: {
    popup: { background: '#fff' },
  },
  onInitialise() {
    runGTM(this.hasConsented());
  },
  onStatusChange() {
    runGTM(this.hasConsented());
  },
  law: {
    regionalLaw: false,
  },
  location: false,
  content: {
    header: 'Cookies used on the website!',
    message: 'This website uses cookies to improve your experience!!!!!!',
    dismiss: 'Got it!',
    allow: 'Allow cookies',
    deny: 'Decline',
    link: 'Learn more',
    href: '/privacy.html',
    close: '&#x274c;',
    policy: 'Cookie Policy',
    target: '_blank',
  },
  elements: {
    header: '<span class="cc-header">The Header</span>',
    message:
      '<span id="cookieconsent:desc" class="cc-message">This website uses cookies to improve your experience.</span>',
    messagelink:
      '<p id="cookieconsent:desc" class="cc-message mb-0">This website uses cookies to improve your experience. <span id="cookieconsent:desc" class="mb-0"> <a aria-label="learn more about cookies" tabindex="0" class="btn btn-secondary btn-sm" href="/privacy.html">Learn more</a></span></p>',
    dismiss:
      '<a id="cc-accept-btn" aria-label="dismiss cookie message" tabindex="0" class="cc-dismiss btn btn-success btn-sm cc-btn' +
      ' ms-2" data-mdb-dismiss="modal" >OK, Thanks</a>',
    allow:
      '<a aria-label="allow cookies" tabindex="0" class="cc-allow btn btn-success btn-sm ms-2 cc-btn">Accept All</a>',
    deny:
      '<a aria-label="deny cookies" tabindex="0" class="cc-deny btn btn-success btn-sm ms-2 cc-btn">Deny</a>',
    link:
      '<a aria-label="learn more about cookies" tabindex="0" class="cc-link" href="" target="_blank">https://www.cookiesandyou.com</a>',
    close:
      '<span aria-label="dismiss cookie message" tabindex="0" class="cc-close">&#x274c;</span>',
    policy: '<span>This is out policy</span>',
  },
});

// function post() {
//   // Create our XMLHttpRequest object
//   // Site key 6LfcBlUaAAAAAEwSD2qKzaFQ3AtqEIvp8alr2CFa
//   console.log("post the form");
//
//   grecaptcha.ready(() => {
//     grecaptcha
//       .execute('6Ld_hEgaAAAAAJSimXcq_AnxjraM51_RWedDFEmM', {
//         action: 'submit',
//       })
//       .then(() => {
//         // Add your logic to submit to your backend server here.
//         const xhttp = new XMLHttpRequest();
//         // Create some variables we need to send to our PHP file
//         const url = 'processForm.php';
//         let vars = '';
//         const elements = document.querySelectorAll('input, textarea');
//         for (let i = 0; i < elements.length; i++) {
//           if (elements[i].value !== '') {
//             const inputName = elements[i].name === '' ? `choice${i}` : elements[i].name;
//             // Do something here
//             vars = `${vars + inputName}=${elements[i].value}&`;
//           }
//         }
//
//         let returnData = '';
//         const postSubmit = document.getElementById('post-submit');
//         const contactForm = document.getElementById('fade-card');
//         //  const status = document.getElementById('status');
//         xhttp.open('POST', url, true);
//         xhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
//         // // Access the onreadystatechange event for the XMLHttpRequest object
//         xhttp.onreadystatechange = function () {
//           if (xhttp.readyState === 4 && xhttp.status === 200) {
//             returnData = xhttp.responseText;
//             document.getElementById('status').innerHTML = returnData;
//             contactForm.classList.add('fade-out');
//             postSubmit.classList.add('fade-in');
//             window.location.href = "thankyou.html";
//           } else {
//             document.getElementById(
//               'status'
//             ).innerHTML = `Sorry we have not been able to send the message: ${returnData}`;
//             contactForm.classList.add('fade-out');
//             postSubmit.classList.add('fade-in');
//           }
//         };
//         // Send the data to PHP now... and wait for response to update the status div
//         xhttp.send(vars); // Actually execute the request
//       });
//   });
//   //  status.innerHTML = 'processing...';
// }
//
// if (typeof window !== 'undefined' && window.document) {
//  const myObject = document.getElementById('submitButton');
//   if (myObject) {
//     myObject.addEventListener('click', post);
//   }
// }
//   (document.getElementById('').addEventListener
//       ? window.addEventListener('click', function(){ps.init(true)}, false)
//       : window.onclick = function(){ps.init(true)});
// }

// import ParticleSlider from '../particle-slider/particleslider.min';
// const init = () => {
//   const isMobile = navigator.userAgent && navigator.userAgent.toLowerCase().indexOf('mobile') >= 0;
//   const isSmall = window.innerWidth < 1000;
//
//   const ps = new ParticleSlider({
//     ptlGap: isMobile || isSmall ? 3 : 0,
//     ptlSize: isMobile || isSmall ? 3 : 1,
//     width: 1e9,
//     height: 1e9
//   });
//
//   const gui = new dat.GUI();
//   gui.add( ps, 'ptlGap' ).min(0).max(5).step(1).onChange(function(){
//     ps.init(true);
//   });
//   gui.add( ps, 'ptlSize' ).min(1).max(5).step(1).onChange(function(){
//     ps.init(true);
//   });
//   gui.add(ps, 'restless');
//   gui.addColor(ps, 'color').onChange(function(value){
//     ps.monochrome = true;
//     ps.setColor(value);
//     ps.init(true);
//   });
//
//   (window.addEventListener
//       ? window.addEventListener('click', function(){ps.init(true)}, false)
//       : window.onclick = function(){ps.init(true)});
// }
export default {
  mdb,
};
